export default __webpack_public_path__ + "assets/link.55d394ce.svg";